/* LOVE ADORNED: lifestyle video tiles in the collection grid.
   Muted, looping, with a pause button. The video file only downloads when the tile is near the screen,
   plays only while visible, and never plays for anyone whose device asks for reduced motion (they see the cover photo).
   Works for tiles that arrive later with infinite scroll, because each <la-tile-video> sets itself up. */
(function () {
  if (customElements.get('la-tile-video')) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { var el = en.target; if (en.isIntersecting) el.wake(); else el.sleep(); });
  }, { rootMargin: '200px 0px' }) : null;

  class LaTileVideo extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.v = this.querySelector('video'); this.btn = this.querySelector('.la-tile__pause');
      this.userPaused = false;
      if (reduce && reduce.matches) return;                      // cover photo only
      this.btn.hidden = false;
      this.btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.userPaused = !this.v.paused ? true : false; this.userPaused ? this.v.pause() : this.play(); this.sync(); });
      this.v.addEventListener('play', () => this.sync()); this.v.addEventListener('pause', () => this.sync());
      if (io) io.observe(this); else this.wake();
    }
    disconnectedCallback() { if (io) io.unobserve(this); }
    load() {
      if (this.loaded) return; this.loaded = true;
      // pick the smallest file that is still sharp enough for this screen
      var want = window.innerWidth < 750 ? 720 : 1080;
      var list = Array.prototype.slice.call(this.v.querySelectorAll('source[data-src]')).sort(function (a, b) { return (+a.dataset.w || 0) - (+b.dataset.w || 0); });
      var best = list.filter(function (s) { return (+s.dataset.w || 0) >= want; })[0] || list[list.length - 1];
      this.v.querySelectorAll('source[data-src]').forEach(function (s) { if (s !== best) s.remove(); });
      if (best) { best.src = best.dataset.src; this.v.load(); }
    }
    play() { var p = this.v.play(); if (p && p.catch) p.catch(function () {}); }
    wake() { this.load(); if (!this.userPaused) this.play(); }
    sleep() { if (this.loaded) this.v.pause(); }
    sync() { var playing = !this.v.paused; this.btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video'); this.classList.toggle('is-paused', !playing); }
  }
  customElements.define('la-tile-video', LaTileVideo);
})();
